import featureFirstImage  from '../images/friend-list-icon.png'
import featureSecondImage  from '../images/friend-list-icon.png'
import featureThirdImage  from '../images/friend-list-icon.png'





export const feature = [
    {
        id: 0,
        image: featureFirstImage,
        heading: 'Watch Parties',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    },
    {
        id: 1,
        image: featureSecondImage,
        heading: 'Friend Lists',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.' 
    },
    {
        id: 2,
        image: featureThirdImage,
        heading: 'User Profiles',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.'
    }
];


//export default Profile;